import * as client_hooks from '../../../src/hooks.client.ts';
import * as universal_hooks from '../../../src/hooks.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116'),
	() => import('./nodes/117'),
	() => import('./nodes/118'),
	() => import('./nodes/119'),
	() => import('./nodes/120'),
	() => import('./nodes/121'),
	() => import('./nodes/122'),
	() => import('./nodes/123'),
	() => import('./nodes/124'),
	() => import('./nodes/125'),
	() => import('./nodes/126'),
	() => import('./nodes/127'),
	() => import('./nodes/128'),
	() => import('./nodes/129'),
	() => import('./nodes/130'),
	() => import('./nodes/131'),
	() => import('./nodes/132'),
	() => import('./nodes/133'),
	() => import('./nodes/134'),
	() => import('./nodes/135'),
	() => import('./nodes/136'),
	() => import('./nodes/137'),
	() => import('./nodes/138'),
	() => import('./nodes/139'),
	() => import('./nodes/140'),
	() => import('./nodes/141'),
	() => import('./nodes/142'),
	() => import('./nodes/143'),
	() => import('./nodes/144'),
	() => import('./nodes/145'),
	() => import('./nodes/146'),
	() => import('./nodes/147'),
	() => import('./nodes/148'),
	() => import('./nodes/149'),
	() => import('./nodes/150'),
	() => import('./nodes/151'),
	() => import('./nodes/152'),
	() => import('./nodes/153'),
	() => import('./nodes/154'),
	() => import('./nodes/155'),
	() => import('./nodes/156'),
	() => import('./nodes/157'),
	() => import('./nodes/158'),
	() => import('./nodes/159'),
	() => import('./nodes/160'),
	() => import('./nodes/161'),
	() => import('./nodes/162'),
	() => import('./nodes/163'),
	() => import('./nodes/164'),
	() => import('./nodes/165'),
	() => import('./nodes/166'),
	() => import('./nodes/167'),
	() => import('./nodes/168'),
	() => import('./nodes/169'),
	() => import('./nodes/170'),
	() => import('./nodes/171'),
	() => import('./nodes/172'),
	() => import('./nodes/173'),
	() => import('./nodes/174'),
	() => import('./nodes/175'),
	() => import('./nodes/176'),
	() => import('./nodes/177'),
	() => import('./nodes/178'),
	() => import('./nodes/179'),
	() => import('./nodes/180'),
	() => import('./nodes/181'),
	() => import('./nodes/182'),
	() => import('./nodes/183'),
	() => import('./nodes/184'),
	() => import('./nodes/185'),
	() => import('./nodes/186'),
	() => import('./nodes/187'),
	() => import('./nodes/188')
];

export const server_loads = [0,2,3,4,5];

export const dictionary = {
		"/": [~6],
		"/adjustments/[id]": [7],
		"/admin": [~8],
		"/admin/announcements": [9],
		"/admin/queues": [~10],
		"/admin/queues/direct": [~11],
		"/cart/review": [~12],
		"/compare": [13],
		"/design-showcase": [14],
		"/docs": [~15,[2]],
		"/docs/customers": [16,[2]],
		"/docs/customers/accounts": [17,[2]],
		"/docs/customers/first-order": [18,[2]],
		"/docs/customers/payments": [19,[2]],
		"/docs/customers/pickup-day": [21,[2]],
		"/docs/customers/pickup": [20,[2]],
		"/docs/customers/shopping": [22,[2]],
		"/docs/customers/support": [23,[2]],
		"/docs/getting-started": [24,[2]],
		"/docs/getting-started/first-week": [25,[2]],
		"/docs/getting-started/market-setup": [26,[2]],
		"/docs/getting-started/overview": [27,[2]],
		"/docs/getting-started/quick-start": [28,[2]],
		"/docs/growers": [29,[2]],
		"/docs/growers/best-practices": [30,[2]],
		"/docs/growers/first-week": [31,[2]],
		"/docs/growers/getting-started": [32,[2]],
		"/docs/growers/harvest": [33,[2]],
		"/docs/growers/onboarding": [34,[2]],
		"/docs/growers/photos": [35,[2]],
		"/docs/growers/pricing": [36,[2]],
		"/docs/growers/products": [37,[2]],
		"/docs/growers/weekly-workflow": [38,[2]],
		"/docs/markdown-guide": [~39,[2]],
		"/docs/market": [40,[2]],
		"/docs/market/automated-scheduling": [41,[2]],
		"/docs/market/checkout-adjustments": [42,[2]],
		"/docs/market/crisis-management": [43,[2]],
		"/docs/market/customer-management": [44,[2]],
		"/docs/market/daily-operations": [45,[2]],
		"/docs/market/email-templates": [46,[2]],
		"/docs/market/financial-management": [47,[2]],
		"/docs/market/grower-onboarding": [48,[2]],
		"/docs/market/marketing": [49,[2]],
		"/docs/market/modern-interface": [50,[2]],
		"/docs/market/multi-market": [51,[2]],
		"/docs/market/opening-closing": [52,[2]],
		"/docs/market/order-problems": [53,[2]],
		"/docs/market/ordering-cycles": [54,[2]],
		"/docs/market/payments": [55,[2]],
		"/docs/market/pickup-locations": [56,[2]],
		"/docs/market/pickup-management": [57,[2]],
		"/docs/market/reports": [58,[2]],
		"/docs/market/seasonal-planning": [59,[2]],
		"/docs/market/settings": [60,[2]],
		"/docs/market/stripe-integration": [61,[2]],
		"/docs/market/themes": [62,[2]],
		"/docs/market/volunteer-management": [63,[2]],
		"/docs/market/weblog": [64,[2]],
		"/docs/support": [65,[2]],
		"/docs/support/community": [66,[2]],
		"/docs/support/contact": [67,[2]],
		"/docs/support/faq": [68,[2]],
		"/docs/support/training": [69,[2]],
		"/docs/support/whats-new": [70,[2]],
		"/docs/technical": [71,[2]],
		"/docs/technical/api": [72,[2]],
		"/docs/technical/data-management": [73,[2]],
		"/docs/technical/integrations": [74,[2]],
		"/docs/technical/security": [75,[2]],
		"/docs/technical/stripe-integration": [76,[2]],
		"/docs/technical/troubleshooting": [77,[2]],
		"/docs/technical/webhooks": [78,[2]],
		"/docs/theming": [79,[2]],
		"/documents": [~80],
		"/faq": [~81],
		"/faq/marketing": [~82],
		"/features": [83],
		"/forgot-password": [84],
		"/growers": [~85],
		"/growers/list": [~88],
		"/growers/map": [~89],
		"/growers/new": [~90],
		"/growers/[id]": [~86],
		"/growers/[id]/edit": [~87],
		"/health": [91],
		"/legacy/faq": [~92],
		"/legacy/growers": [~93],
		"/legacy/growers/map": [~96],
		"/legacy/growers/new": [~97],
		"/legacy/growers/[id]": [~94],
		"/legacy/growers/[id]/edit": [~95],
		"/legacy/market": [~98],
		"/legacy/photos/new": [~100],
		"/legacy/photos/[id]": [~99],
		"/legacy/recipes": [~101,[3]],
		"/legacy/recipes/new": [~104,[3]],
		"/legacy/recipes/[id]": [~102,[3]],
		"/legacy/recipes/[id]/edit": [~103,[3]],
		"/legacy/weblog": [~105],
		"/legacy/weblog/view/[id]": [~107],
		"/legacy/weblog/[id]": [~106],
		"/legacy/welcome": [~108],
		"/legal": [~109],
		"/legal/[page]": [~110],
		"/locations": [~111],
		"/locations/map": [~112],
		"/markets": [~114],
		"/markets/edit": [~115],
		"/markets/list": [116],
		"/markets/map": [~117],
		"/markets/new": [~118],
		"/markets/new/success": [~119],
		"/market": [~113],
		"/modern/faq": [~120],
		"/modern/growers": [~121],
		"/modern/growers/map": [~124],
		"/modern/growers/new": [~125],
		"/modern/growers/[id]": [~122],
		"/modern/growers/[id]/edit": [~123],
		"/modern/market": [~126],
		"/modern/photos/new": [~128],
		"/modern/photos/[id]": [~127],
		"/modern/recipes": [~129],
		"/modern/recipes/new": [~132],
		"/modern/recipes/[id]": [~130],
		"/modern/recipes/[id]/edit": [~131],
		"/modern/weblog": [~133],
		"/modern/weblog/view/[id]": [~135],
		"/modern/weblog/[id]": [~134],
		"/modern/welcome": [~136],
		"/order_items/chargebacks": [~137],
		"/order_items/refunds": [~138],
		"/orders": [~139],
		"/orders/by-location": [~142],
		"/orders/checkin": [~143],
		"/orders/checkout": [~144],
		"/orders/harvest_by_location/[id]": [~146],
		"/orders/harvest_history/[growerId]": [~147],
		"/orders/harvest/[id]": [~145],
		"/orders/list": [~148],
		"/orders/payment_summary": [~149],
		"/orders/unclaimed": [~150],
		"/orders/[id]": [140],
		"/orders/[id]/edit": [~141],
		"/photos/new": [~152],
		"/photos/[id]": [~151],
		"/pricing": [153],
		"/products": [~154],
		"/recipes": [~155,[4]],
		"/recipes/new": [~158,[4]],
		"/recipes/[id]": [~156,[4]],
		"/recipes/[id]/edit": [~157,[4]],
		"/reset-password/[token]": [~159],
		"/roadmap": [~160],
		"/showcase": [161,[5]],
		"/showcase/accessibility": [162,[5]],
		"/showcase/animations": [163,[5]],
		"/showcase/components": [164,[5]],
		"/showcase/components/data": [165,[5]],
		"/showcase/components/feedback": [166,[5]],
		"/showcase/components/forms": [167,[5]],
		"/showcase/components/layout": [168,[5]],
		"/showcase/components/market": [169,[5]],
		"/showcase/components/navigation": [170,[5]],
		"/showcase/design-system": [171,[5]],
		"/showcase/examples": [172,[5]],
		"/showcase/examples/checkout-flow": [173,[5]],
		"/showcase/layouts": [174,[5]],
		"/signin": [~175],
		"/story": [~176],
		"/users/list": [~182],
		"/user/change-password": [~177],
		"/user/edit": [~178],
		"/user/history/adjustments": [~179],
		"/user/history/orders": [~180],
		"/user/signin": [~181],
		"/weblog": [~183],
		"/weblog/template-preview": [~185],
		"/weblog/view/[id]": [~186],
		"/weblog/[id]": [~184],
		"/welcome": [~187],
		"/why-not-open-source": [~188]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: universal_hooks.reroute || (() => {}),
	transport: universal_hooks.transport || {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';